import { createApi } from '@reduxjs/toolkit/query/react'
import { BaseRequest } from '../models'
import { baseQueryWithTokenRefresh } from '../../common/baseQuery'

const _BASE_URL = import.meta.env.REACT_APP_QUESTION_INSIGHTS_API_BASE_URL!

export interface LikelyQuestion {
  id: string
  text: string
}

export interface LikelyQuestionsResponse {
  questions: LikelyQuestion[]
}

export interface GetLikelyQuestionsRequest extends BaseRequest {
  window?: string
  limit?: number
}

export const questionInsightsApi = createApi({
  reducerPath: 'questionInsightsApi',
  baseQuery: baseQueryWithTokenRefresh(_BASE_URL),
  endpoints: (builder) => ({
    getLikelyQuestions: builder.query<LikelyQuestion[], GetLikelyQuestionsRequest>({
      query: ({ accountId, window, limit }) => ({
        url: `/v1/accounts/${accountId}/likely-questions`,
        method: 'GET',
        params: { window, limit },
      }),
      transformResponse: (response: LikelyQuestionsResponse) => response.questions ?? [],
    }),
  }),
})

export const { useGetLikelyQuestionsQuery } = questionInsightsApi
